import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EkubsAnalyticsComponent } from './ekubs.analytics.component';
import { EkubAnalyticsComponent } from './ekub.analytics.component';
import { SimulatorComponent } from './simulator.component';
import { PreferencesComponent } from './preferences.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'ekubsAnalytics', component: EkubsAnalyticsComponent, data: { title: 'Ekub Analytics' } },
    { path: 'ekubAnalytics/:id', component: EkubAnalyticsComponent, data: { title: 'Ekub Analytics' } },
    { path: 'simulator', component: SimulatorComponent, data: { title: 'Simulator' } },
    { path: 'preferences', component: PreferencesComponent, data: { title: 'Preferences' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AnalyticsRoutingModule { }
